<template>
  <div class="full">
    <!-- <nav>
    </nav> -->
          <!-- <div class="region"> -->
      <!-- <div class="full"> -->
      <!-- <div class="topBar"> -->
        <!-- <div class="expendDiv">
        </div>-->

        <!-- <div class="topTitle">
        </div> -->
        <div class="topTitle" >
          <div class="flex-item stick-item icon">
            <el-icon v-if="$route.path != '/login'" @click="onReturn"><Back /></el-icon>
          </div>
          <div class="flex-item">
          {{  $t($route.meta.title) }} 
          </div>
          <div class="flex-item stick-item" ><span v-if="accountId"  @click="logout">{{  $t('login.logoutBtn') }} </span></div>
        </div>
        <div class="loginBackground">
        <div class="languageSelect">
          <div class="langurage-item"
            @click="selectLang('en')"
            :class="language === 'en' ? 'active' : ''"
            >English</div
          >
          <div class="langurage-item"
            @click="selectLang('kr')"
            :class="language === 'kr' ? 'active' : ''"
            >한국어</div
          >
          <div class="langurage-item"
            @click="selectLang('ja')"
            :class="language === 'ja' ? 'active' : ''"
            >日本語</div
          >
          <div class="langurage-item"
            @click="selectLang('zh')"
            :class="language === 'zh' ? 'active' : ''"
            >简体中文</div>
          </div>
      <!-- </div>  -->


        <!-- <div class="loginBackground">
          <div class="image" :class="useRegistBackground ? 'regist-bg': ''"></div>
        </div> -->
          <div class="main">
            <div class="logo" :class="language == 'zh'? '': 'global'"></div>
             <!-- <div class="returnBtn" v-if="accountId">
              <el-button type="secondary" class="btn" circle @click="logout()">{{$t('login.logoutBtn')}}</el-button>
             </div> -->
            <router-view />   
            <div class="jingtengtech">{{$t('companyName')}}</div>
          </div>        
      </div>
    <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import { appStore } from './stores/app';
import { userStore } from './stores/user';
import { mapState } from 'pinia';
// import { getToken } from '@/utils/auth'

const BASE_FONT_SIZE = 16;

export default {  
  
   data(){
    return {
      // hasToken: false
      // useRegistBackground: false,
      // routeTitle: '',
      // showNavBar: true
    }
  },

  mounted(){
    // console.log(`main clientId: ${this.clientApp}`, this.$router.query);
    
    // this.hasToken = getToken();
    console.log('app main', this.$router, this.$route)
    
    this.resize();
  },

  computed: {
    ...mapState(appStore, ['language']),
    ...mapState(userStore, ['accountId'])
  },

  watch: {
    accountId: {
      handler: function (val, oldVal) {
  //       // 
  //       this.myRule = {
  //         username: [{ required: true, message: this.$t('login.inputUsername'), trigger: 'blur' }],
  //         password: [{ required: true, message: this.$t('login.inputPassword'), trigger: 'blur' }]
  //       }
      },
      deep: true
    },
    '$route'(to, from) {
      // to 和 from 分别代表导航前的路由对象和导航后的路由对象
      console.log('路由发生变化');
      console.log('从', from, '导航到', to);
      console.log('test', this.$route.meta, to.meta)
      this.routeTitle = this.$t(this.$route.meta.title)
      console.log('routeTitle', this.$route, this.routeTitle, this.$route.meta.title)
      // 执行其他操作...
    }
  },

  methods: {

    
    selectLang(lang) {
      appStore().setLangurage(lang);
    },

    resize(){
      // const that = this;
      const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
     
    //  const isMobile = settings.isMobile;
    //  console.log('isMobile', isMobile)

     const pcStandardSize = {
       width: 1920,
       height: 1080
     }

     const mobileStandardSize = {
       width: 430,
       height: 932
     } 

     const standardSize = isMobile ? mobileStandardSize : pcStandardSize;

      window.onresize = function temp() {
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        document.documentElement.style.fontSize = `${width / standardSize.width * BASE_FONT_SIZE}px`;
      };
      window.onload = function temp() {        
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        
        document.documentElement.style.fontSize = `${width / standardSize.width * BASE_FONT_SIZE}px`;
        // console.log('width', width, 'height', height, document.documentElement.style.fontSize)
      };
    },

    onReturn() {
      this.$router.push({path: '/'})
    },

    // onNavBarChange(showNavBar) {
    //   this.showNavBar = showNavBar;
    // },
    
    logout() {
      // console.log('aaaa', appStore())
      userStore().logout();
      // this.$router.push({ 'path': `/${appStore().appRoute}` })
      // console.log('bbb')
      this.$router.push({ name: `login` });
      // this.$router.push({ name: 'RaMain' })
    }
  }


} 

</script>

<style lang="scss" scoped>
// .region{
//   position: relative;
//   height: 100%;
// }
// body, html {
//   width: 100%;
// }

.full{
  position: relative;
  width: 100%;
  padding: 0;
  // position: absolute;
  // left: 0;
  // right: 0;
  // top: 0;
  // bottom: 0;
  background: url('~@/assets/background.png') no-repeat center;
  background-size: cover;
  // width: 100%;
  height: calc(100vh - 0px);
  // overflow: hidden;
  // border: 1px solid pink;

  // &.contain{
  //   position: relative;
  // }

  .loginBackground{

    padding: 0 2.19rem;
  }
}

.topTitle{
  // width: 35.83rem;
  height: 4.32rem;
  background: #285AC4;
  border-radius: 0rem 0rem 0rem 0rem;
  line-height: 4.32rem;
  text-align: center;
  font-size: 1.5rem;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 1.75rem;
  user-select: none;


  .flex-item{
    flex-grow: 1;

    &.stick-item{
      width: 1.8rem;
      flex-grow: 0;
      flex-shrink: 0;
      font-size: 0.88rem;
      font-weight: normal;
      padding: 0;
    }

    &.icon{
      font-size: 1.5rem;
      font-weight: bolder;
    }
  }
}

.jingtengtech{
      position: absolute;
      left: 0;
      right:0;
      margin: auto;
      height: 0.63rem;
      font-size: 0.75rem;
      font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
      font-weight: 400;
      color: #A4A0A0;
      line-height: 0.63rem;
      bottom: 1.13rem;
      user-select: none;
      // border:1px solid pink;
    }


    
.languageSelect {
   position: absolute;
      left: 0;
      right:0;
      margin: auto;
      bottom: 3.5rem;
      height: auto;
      width: inherit;
      overflow: scroll;
      margin: 0 2.19rem;

    
    // margin-top: 2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .langurage-item {
      display: block;
      // flex: 1;
      flex-grow: 0;
      // flex-shrink: 1;
      color: #A4A0A0;
      font-size: 0.88rem;
      transition: all 0.3s;
      cursor: pointer;
      // margin-left: 1rem;
      padding: 0rem;
      width: 5rem;
      height: 2rem;
      line-height: 2rem;
      // background: #859DD4;
      // border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
      // border: 1px solid #A4A0A0;
      // border-radius: 0.2rem;
      // background-color: rgba(255,255,255,0);
      
      background: #F1F2F7;
      border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
    }
    .langurage-item:hover {
      color: #fff;
      background: #859DD4;
      // border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
      // text-decoration: underline;
    }
    .active{
      color: #fff;
      // border: 1px solid #fff;
      // background-color: rgba(255,255,255,0.2);
      background: #859DD4;
      // border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
    }
  }
</style>
